import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { forkJoin, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CourseApiServiceService {

  constructor(private http: HttpClient) { }
  apiUrl = environment.apiUrl; getAllCourses(page?: number, type?: string) {
    const params = new URLSearchParams();
    if (page !== undefined && page !== null) {
      params.set('page', page.toString());
    }
    if (type && type !== 'all') {
      params.set('course_type', type);
    }
    const query = params.toString();
    return this.http.get(`${this.apiUrl}course/get-all-details${query ? `?${query}` : ''}`);
  }

  getCourseById(id: number) {
    return this.http.get(`${this.apiUrl}course/get-course/${id}`);
  }

  

  getCourseStructure(id: number) {
    return this.http.get(`${this.apiUrl}course/get-course-structure/${id}`);
  }

  getCourseAchivements(id: number) {
    return this.http.get(`${this.apiUrl}course/get-course-achievements/${id}`);
  }

  getCoursePrice(id: number) {
    return this.http.get(`${this.apiUrl}course/get-course-price/${id}`);
  }

  setCourseDetails(data: any, id: number) {
    return this.http.post(`${this.apiUrl}course/create/${id}`, data);
  }



  setCoursePrice(data: any, id: number) {
    return this.http.post(`${this.apiUrl}course/create/price/${id}`, data);
  }

  getCourseFullDetails(id: number): Observable<any> {
    return forkJoin({
      course_details: this.http.get(`${this.apiUrl}course/get-course/${id}`),
      course_structure: this.http.get(`${this.apiUrl}course/get-course-structure/${id}`),
      course_achievements: this.http.get(`${this.apiUrl}course/get-course-achievements/${id}`),
      course_price: this.http.get(`${this.apiUrl}course/get-course-price/${id}`),
    });
  }

  // enum = [
  //   {
  //     id: 1, name: 'users_role', value: [
  //       { id: 1, role: 'admin', slud: 'admin' },
  //       { id: 2, role: 'client', slud: 'client' },
  //       { id: 3, role: 'isv', slud: 'isv' },
  //       { id: 4, role: 'partner', slud: 'partner' },
  //       { id: 4, role: 'coseller', slud: 'coseller' },
  //       { id: 4, role: 'partner_cosell', slud: 'partnerpartner_cosell' },
  //     ]
  //   },
  //   {
  //     id: 2, name: 'taxonomy', value: [
  //       { id: 1, name: 'features', type: 'input | textarea | multi_select | select | radio | checkbox', slud: 'features', data: [] },
  //       { id: 1, name: 'industry', type: 'multi_select', slud: 'features', data: ['healthcare', 'finance', 'education', 'healthcare', 'finance', 'education', 'healthcare', 'finance', 'education'] },
  //     ]
  //   },
  //   {
  //     id:3,name:'product_type',value:[
  //       {id:1,action_type:'product'},
  //       {id:2,action_type:'bundle'}
  //     ]
  //   },
  //   {
  //     id:4,name:'status',value:[
  //       {id:1,action_type:'pending'},
  //       {id:2,action_type:'active'}
  //     ]
  //   }
  // ]




}





